<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="false"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
      :goback="true"
    >
    </common-top-form>

    <common-table
      :data="tableData"
      ref="commonTable"
      :isShow="false"
      @handleChange="getPage"
    >
      <el-table-column
        prop="merCode"
        min-width="180"
        label="本地商户ID"
      ></el-table-column>
      <!-- <el-table-column
        prop="dateStart"
        min-width="100"
        label="通道名称"
        :formatter="formatterTableData"
      ></el-table-column> -->
      <el-table-column
        prop="acqMerCode"
        min-width="180"
        label="通道商户编码"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="acqTidCode"
        label="通道终端号"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="shopSncode"
        label="终端SN"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="openStatus"
        label="绑定状态"
        min-width="100"
        :formatter="formatterTablestatus"
        show-overflow-tooltip
      >
           <template slot-scope="scope">
          <span v-if="scope.row.openStatus == 0">已绑定</span>
          <span v-else-if="scope.row.openStatus == 1">未绑定（绑定中）</span>
          <span v-else-if="scope.row.openStatus == 2">绑定失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="终端状态"
        min-width="100"
        :formatter="formatterTablestatus"
        show-overflow-tooltip
      >
           <template slot-scope="scope">
          <span v-if="scope.row.status == 0">已开通</span>
          <span v-else-if="scope.row.status == 1">未开通（审核中）</span>
          <span v-else-if="scope.row.status == 2">开通失败</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="remarks"
        label="备注"
        min-width="100"
        :formatter="formatterTablestatus"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >开通新终端
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column> -->
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TransactionService from "service/TransactionService";
import FinanceService from "service/FinanceService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "twoapppointsnewodetoJoyinfolook",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      isPage: false,
      page: {},
      formModel: {},
      impiementall: {},
      submitService: FinanceService.merAcqTidCnvList,
      tableData: [],
      status: [
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
        {
          dictKey: "3",
          dictValue: "已完成",
        },
      ],
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        tidCode: JSON.parse(this.$route.params.item).tidCode,
        pId: this.impiementall.id,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  created() {
    console.log(
      JSON.parse(this.$route.params.item).merCode,
      "this.$route.params.itemthis.$route.params.item"
    );
    this.impiementall = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  watch: {},
  methods: {
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/POSPTerminalManagement/ChannelTerminal.vue